// Lesson 6 — Winning: Tsumo & Ron. The learner starts one tile from a complete
// hand (three runs + a Red Dragon pair + 5-6 Bamboo waiting on 4 or 7). After
// discarding a lone floater, three pass-through bots shed their honours and the
// learner draws the winning 7-Bamboo off the crafted wall front — a fully
// deterministic self-draw — to declare Tsumo. Ron (winning off a discard) is
// taught alongside as an info step; a single hand can hold only one win, so the
// self-draw is the interactive climax (see the plan's determinism note).

import { createDealBuilder, fillerBot } from './deckBuilder.js';
import type { LessonScript } from '../types.js';

const b = createDealBuilder();

const sou5 = b.suit('sou', 5);
const sou6 = b.suit('sou', 6);
const white = b.honor('white');

const human = [
  ...b.run('man', 2),
  ...b.run('man', 6),
  ...b.run('pin', 2),
  sou5,
  sou6,
  b.honor('red'),
  b.honor('red'),
];

const seat1 = fillerBot(b, 'east', [['pin', 1], ['pin', 5], ['sou', 1], ['man', 1]]);
const seat2 = fillerBot(b, 'south', [['sou', 4], ['sou', 7], ['man', 4], ['pin', 7]]);
const seat3 = fillerBot(b, 'north', [['man', 6], ['pin', 2], ['sou', 1], ['sou', 5]]);

// The learner draws white (opening), discards it, then draws sou7 for the Tsumo.
const sou7 = b.suit('sou', 7);
const wall = [white, b.suit('man', 5), b.suit('pin', 5), b.suit('man', 5), sou7];

export const lesson6Winning: LessonScript = {
  id: 'lesson-6-winning',
  titleKey: 'lesson.script.winning.title',
  deal: { hands: [human, seat1, seat2, seat3], wall },
  steps: [
    {
      instructionKey: 'lesson.script.winning.intro',
      expectedAction: { kind: 'info' },
      highlightTileIds: [sou5.id, sou6.id],
      autoAdvance: false,
    },
    {
      instructionKey: 'lesson.script.winning.discard',
      expectedAction: { kind: 'discard', tileId: white.id },
      highlightTileIds: [white.id],
      autoAdvance: true,
    },
    { instructionKey: 'lesson.script.winning.ways', expectedAction: { kind: 'info' }, autoAdvance: false },
    {
      instructionKey: 'lesson.script.winning.tsumo',
      expectedAction: { kind: 'tsumo' },
      highlightTileIds: [sou7.id],
      autoAdvance: true,
    },
    { instructionKey: 'lesson.script.winning.done', expectedAction: { kind: 'info' }, autoAdvance: false },
  ],
};
